// extracted by mini-css-extract-plugin
module.exports = {"body":"styles_body__2F_-d","header":"styles_header__1-faT","containerButtons":"styles_containerButtons__2_KqU","button":"styles_button__3hPGi"};